import { SortDirection } from '../../enums/sort-direction';
import { DataSort } from '../data-sort';

export const DEFAULT_PAGE_SIZE = 10;

export interface BaseState {
  isLoading?: boolean;
  error?: unknown;
  sortDirection?: SortDirection;
  isAtEndOfData?: boolean;
  sortBy?: DataSort;
  pageNumber?: number;
  pageSize?: number;
  totalRecordCount?: number;
  searchTerm?: string | null;
  isActive?: boolean | null;
}

export function createBaseState(sortBy: DataSort | undefined): BaseState {
  return {
    isLoading: false,
    error: null,
    sortDirection: SortDirection.Ascending,
    isAtEndOfData: false,
    sortBy,
    pageNumber: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    totalRecordCount: 0,
    searchTerm: null,
    isActive: true,
  };
}
